export default __webpack_public_path__ + "static/media/life_insurance.c322af17.webp";